import { render, staticRenderFns } from "./StudioMultiSelect.vue?vue&type=template&id=070bfce1&scoped=true&"
import script from "./StudioMultiSelect.vue?vue&type=script&lang=js&"
export * from "./StudioMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./StudioMultiSelect.vue?vue&type=style&index=0&id=070bfce1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bfce1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemAction } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
installComponents(component, {VDivider,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
